// extracted by mini-css-extract-plugin
export var content = "_be-3";
export var list = "_be-4";
export var settingsContent = "_be-7";
export var settingsPanel = "_be-8";
export var state = "_be-6";
export var triggerBadge = "_be-2";
export var triggerButton = "_be-1";
export var triggerShell = "_be-0";
export var unreadDot = "_be-5";